import React from 'react';
import PropTypes from 'prop-types';
import Card from '../components/card';
import Section from '../components/section';

const RoomsTemplate = ({ items }) => (
  <Section title="Номера">
    <div className="row row--wrap">
      {items.map(({ node: room }) => (
        <div key={room.id} className="col-xs-12 col-md-3 rooms-item wow fadeInUp">
          <Card {...room} />
        </div>
      ))}
    </div>
  </Section>
);

RoomsTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default RoomsTemplate;
